import { useEffect, useState } from "react";
import { useAuth } from "../../hooks/useAuth";
import { getAssignedPromoters, getSalesByMonthForPromoters, getTargetsForPromoters, getPendingSalesByPromoters, getPendingAppealsByPromoters, getBanners } from "../../firebase/services";
import { format } from "date-fns";
import { useLanguage } from "../../hooks/useLanguage";
import BannerSlider from "../../components/BannerSlider";

export default function SupervisorDashboard() {
  const { user, profile } = useAuth();
  const month = format(new Date(), "yyyy-MM");
  const [promoters, setPromoters] = useState([]);
  const [stats, setStats] = useState({ totalPromoters: 0, pendingSales: 0, pendingAppeals: 0, totalSalesThisMonth: 0 });
  const [loading, setLoading] = useState(true);
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    getBanners().then(setBanners).catch(() => {});
  }, []);

  useEffect(() => {
    if (!user) return;
    const load = async () => {
      setLoading(true);
      const proms = await getAssignedPromoters(user.uid);
      const ids = proms.map(p => p.uid);
      const [sales, targets, pendingSales, pendingAppeals] = await Promise.all([
        getSalesByMonthForPromoters(month, ids),
        getTargetsForPromoters(month, ids),
        getPendingSalesByPromoters(ids),
        getPendingAppealsByPromoters(ids),
      ]);
      setPromoters(proms);
      setStats({
        totalPromoters: proms.length,
        pendingSales: pendingSales.length,
        pendingAppeals: pendingAppeals.length,
        totalSalesThisMonth: sales.length,
      });
      setLoading(false);
    };
    load();
  }, [user]);

  const { t } = useLanguage();
  if (loading) return <div style={{ color: "#888", padding: 20 }}>{t("common.loading")}</div>;

  return (
    <>
      <BannerSlider banners={banners} />
      <div className="page-header">
        <div>
          <h1>{t("dash.hello")}, {profile?.name} 👋</h1>
          <p>{t("x.month")} {month} — {stats.totalPromoters} {t("dash.group_note")}</p>
        </div>
      </div>

      <div className="metrics-grid">
        <div className="metric-card">
          <div className="metric-label">{t("sv_dash.my_group")}</div>
          <div className="metric-value">{stats.totalPromoters}</div>
        </div>
        <div className="metric-card">
          <div className="metric-label">{t("sv_dash.total_sales")}</div>
          <div className="metric-value">{stats.totalSalesThisMonth}</div>
        </div>
        <div className="metric-card">
          <div className="metric-label">{t("sv_dash.pending_sales")}</div>
          <div className="metric-value" style={{ color: stats.pendingSales > 0 ? "#ef9f27" : undefined }}>
            {stats.pendingSales}
          </div>
        </div>
        <div className="metric-card">
          <div className="metric-label">{t("dash.appeals_pending")}</div>
          <div className="metric-value" style={{ color: stats.pendingAppeals > 0 ? "#ef9f27" : undefined }}>
            {stats.pendingAppeals}
          </div>
        </div>
      </div>

      <div className="card" style={{ marginTop: 20 }}>
        <div className="card-header"><div className="card-title">{t("sv_dash.promoter_list")}</div></div>
        {promoters.length === 0 ? (
          <div style={{ color: "#aaa", textAlign: "center", padding: 24 }}>{t("sv_dash.no_promoters")}</div>
        ) : (
          <table className="table-card">
            <thead><tr><th>{t("common.name")}</th><th>{t("sales.shop")}</th><th>{t("common.email")}</th></tr></thead>
            <tbody>
              {promoters.map(p => (
                <tr key={p.uid}>
                  <td data-label="Họ tên"><strong>{p.name}</strong></td>
                  <td data-label="Shop">{p.shopName}</td>
                  <td data-label="Email" style={{ color: "#888", fontSize: 12 }}>{p.email}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
